import { TypographyProps } from '@pogokid/mui'
import cx from 'classnames'
import styles from './Headline.module.css'
import { PropsWithChildren } from 'react'

interface HeadlineProps {
  component?: TypographyProps['component']
  size?: 'lg' | 'xl'
}

export function Headline({
  children,
  size,
  component,
}: PropsWithChildren<HeadlineProps>) {
  const Component = component ?? 'h2'
  return (
    <Component
      className={cx(styles.Headline, {
        [styles.isSizeXl]: size === 'xl',
        [styles.isSizeLg]: !size || size === 'lg',
      })}
    >
      {children}
    </Component>
  )
}
